module.exports = __webpack_public_path__ + "static/4b1ba4b297c1918e7579f53ea56484224761b8b3453538de340af804bc822988-86b322910827056e8215fec6c3422bab.png";